window.__assetPrefix__ = 'https://d2bb69ycivbweh.cloudfront.net/frontend-payroll';